import React, { useState, useEffect } from 'react'
import { Breadcrumb, Row, Col, Button, Input, Layout, theme, Modal, Space, Table, Badge, Drawer, Pagination } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Formik } from 'formik';
import AsyncStorage from '@react-native-async-storage/async-storage';

import {
  CloseOutlined,
  LoadingOutlined,
  ExclamationCircleFilled
} from '@ant-design/icons';

//Dispatchs
import { Creators as AdministratorsActions } from '../../store/reducers/administrators';
import { Creators as RefreshActions } from '../../store/reducers/refresh';
//Styles And Helpers

//Contexts

//Components
import FooterDefault from '../../components/LayoutDefault/FooterDefault'
import Add from './actions/Add';
import Edit from './actions/Edit';

//Variables

const { Content } = Layout;
const { confirm } = Modal;

const Administrators = () => {

  const navigate = useNavigate();

  //Dispatchs
  const dispatch = useDispatch();

  //States Reducer
  const { dataList, loadingList, dataListUpdate } = useSelector((state) => (state.administrators))
  const { data } = useSelector((state) => (state.authentication))

  //States Local
  const {
    token: { colorBgContainer, colorSuccess, colorError, colorInfo },
  } = theme.useToken();

  //---- Open Filter Table
  const [openModalFilter, setOpenModalFilter] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);

  const title = 'Adiministradores'
  const [openTypeContentDrawer, setOpenTypeContentDrawer] = useState({
    edit: {
      status: false,
      title: `Editar ${title}`,
      dataEdit: {}
    },
    add: {
      status: false,
      title: `Adicionar ${title}`
    },
  });
  const [filters, setFilters] = useState({ first_name: '', last_name: '', email: '' });
  const [drawerWidthResponsiveShow, setDrawerWidthResponsiveShow] = useState('40%'); // Largura inicial do Drawer

  //Context

  //Cicle of Life
  useEffect(() => {
    document.title = 'Adiministradores - Iguaçu Máquinas';
    const autoLogin = async () => {
      const refreshToken = await AsyncStorage.getItem('iguacu:refresh');
      dispatch(RefreshActions.getRefreshRequest({ token: refreshToken }));
      // eslint-disable-next-line react-hooks/exhaustive-deps
      return refreshToken
    }
    autoLogin()

    window.addEventListener('resize', handleResize); // Adiciona um event listener para redimensionamento da janela
    // Remove o event listener quando o componente é desmontado
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    updateDataList('1')
  }, []);

  useEffect(() => {
    if (dataListUpdate) {
      updateDataList('1')
    }
  }, [dataListUpdate]);

  //Functions
  const handleResize = () => {
    const width = window.innerWidth;
    if (width <= 900) {
      setDrawerWidthResponsiveShow('100%');
    } else {
      setDrawerWidthResponsiveShow('50%'); // Largura padrão do Drawer
    }
  };

  const updateDataList = (selectedPage) => {
    let payloadList = {
      page: selectedPage,
      first_name: filters.first_name,
      last_name: filters.last_name,
      email: filters.email
    }
    // console.log('payloadList', payloadList)
    dispatch(AdministratorsActions.getAdministratorsListRequest(payloadList))
  }

  //---Filter
  const updateFilter = () => {
    updateDataList(1)
    setOpenModalFilter(false)
  }

  const setFieldFilter = (name, value) => {
    setFilters(prevFilters => ({
      ...prevFilters,
      [name]: value
    }))
  }

  const resetFilters = () => {
    setFilters({ first_name: '', last_name: '', email: '' });
    let payloadList = {
      page: '1',
      first_name: '',
      last_name: '',
      email: ''
    }
    // console.log('payloadList', payloadList)
    dispatch(AdministratorsActions.getAdministratorsListRequest(payloadList))
  }

  const showModalFilter = () => {
    setOpenModalFilter(true);
  }
  const hideModalFilter = () => {
    setOpenModalFilter(false);
  }


  //---Drawer Actions Adicionar || Deletar
  const showDeleteConfirm = (data) => {
    confirm({
      title: `Tem certeza que deseja deletar ?`,
      icon: <ExclamationCircleFilled />,
      content: ` ${data?.full_name}`,
      okText: 'SIM',
      okType: '',
      cancelText: 'NÃO',
      onOk() {
        // console.log('OK');
        dispatch(AdministratorsActions.deleteAdministratorsDelRequest({ id: data?.id }))
      },
    });
  };
  const showDrawer = () => {
    setOpenDrawer(true);
  };
  const onCloseDrawer = () => {
    setOpenDrawer(false);
    setOpenTypeContentDrawer({
      edit: {
        status: false,
        title: `Editar ${title}`,
        dataEdit: {}
      },
      add: {
        status: false,
        title: `Adicionar ${title}`
      },
    })
  };

  const handleChangeTypeContentDrawer = (name, dataEdit = {}) => {

    if (dataEdit.id === data?.profile?.id) {
      return navigate('/acount');
    }

    if (name === 'add') {
      setOpenTypeContentDrawer({
        edit: {
          status: false,
          title: `Editar ${title}`,
          dataEdit: {}
        },
        add: {
          status: true,
          title: `Adicionar ${title}`
        },
      })
    } else if (name === 'edit') {
      setOpenTypeContentDrawer({
        edit: {
          status: true,
          title: `Editar ${title}`,
          dataEdit: dataEdit
        },
        add: {
          status: false,
          title: `Adicionar ${title}`
        },
      })
    }
    showDrawer()
  }

  const getTitle = () => {
    if (openTypeContentDrawer?.add?.status) {
      return openTypeContentDrawer?.add?.title
    } else if (openTypeContentDrawer?.edit?.status) {
      return openTypeContentDrawer?.edit?.title
    }
  }

  //---Configurations Columns Table
  const columns = [
    {
      title: 'Nome',
      dataIndex: 'first_name',
      key: 'first_name',
    },
    {
      title: 'Sobrenome',
      dataIndex: 'last_name',
      key: 'last_name',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Ativo',
      dataIndex: 'is_active',
      key: 'is_active',
      render: (text, i) =>
        <div >
          {(text === 1) ?
            <Badge color="green" text={'ativo'} />
            :
            <Badge color="volcano" text={'inativo'} />
          }
        </div>
      ,
    },
    {
      title: 'Ações',
      dataIndex: 'actions',
      key: 'actions',
      render: (text, record, index) => (
        < Space size="middle" >
          <Button
            size='small' type="primary" style={{ background: colorInfo }}
            onClick={() => handleChangeTypeContentDrawer('edit', record)}
          >
            editar
          </Button>
          <Button
            size='small' type="primary" style={{ background: colorError }}
            onClick={() => showDeleteConfirm(record)}
          >
            Deletar
          </Button>
        </Space >
      ),
    },
  ];

  //Render
  return (
    <>
      <Content>
        <Breadcrumb
          className='breadcrumb px-3 py-2'
          items={[{ title: 'Usuários Administradores' }]}
        />
        <div
          className='px-4 py-3'
          style={{
            background: colorBgContainer,
          }}
        >
          <div className='container'>
            <div className='row justify-content-between'>
              <div className='p-2'>
                <Button
                  size='small'
                  className='m-2'
                  type="primary"
                  style={{ background: colorInfo }}
                  onClick={showModalFilter}
                >
                  Adicionar Filtros
                </Button>
                <Button
                  size='small'
                  className='m-2'
                  onClick={() => {
                    resetFilters()
                  }}
                  style={{
                    background: colorError,
                  }}
                  type='primary'
                >
                  Limpar Filtros
                </Button>
              </div>
              <div className='p-2'>
                <Button
                  size='small'
                  className='m-2'
                  onClick={() => {
                    handleChangeTypeContentDrawer('add', true)
                  }}
                  style={{
                    background: colorSuccess,
                  }}
                  type='primary'
                >
                  Adicionar
                </Button>
              </div>
            </div>
          </div>
          <div className='table-content'>
            <Table pagination={false} loading={(loadingList) && { indicator: <LoadingOutlined /> }} rowKey="id" columns={columns} dataSource={dataList?.data} />
          </div>
          {
            dataList?.last_page > 1 &&
            <div className='m-3 text-right'>
              <Pagination
                pageSize={dataList?.per_page}
                showSizeChanger={false}
                showTotal={(total, range) => `${total} itens`}
                onChange={(e) => updateDataList(e)}
                current={dataList?.current_page}
                defaultPageSize={`${dataList?.per_page}`}
                total={dataList?.total}
              />
            </div>
          }
        </div>

        {/* Modal Filters */}
        <Modal title="Filtros"
          open={openModalFilter}
          footer={null}
          onCancel={hideModalFilter}
        >
          <div className='p-2' style={{ backgroundColor: '#f0f2f5' }}>
            <Formik
              initialValues={{
                first_name: filters?.first_name,
                last_name: filters?.last_name,
                email: filters?.email
              }}
              onSubmit={() => (
                updateFilter()
              )
              }
            >
              {({ handleSubmit, values, errors, touched }) => (
                <div>
                  <Row gutter={[16, 16]}>
                    <Col span={12}>
                      <label className='p-2' htmlFor="first_name">Nome</label>
                      <Input
                        className='input-default'
                        value={filters.first_name}
                        onChange={(e) => setFieldFilter('first_name', e.target.value)}
                        size="large"
                        placeholder="Nome"
                      />
                    </Col>
                    <Col span={12}>
                      <label className='p-2' htmlFor="last_name">Sobrenome</label>
                      <Input
                        className='input-default'
                        value={filters.last_name}
                        onChange={(e) => setFieldFilter('last_name', e.target.value)}
                        size="large"
                        placeholder="Sobrenome"
                      />
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={24}>
                      <label className='p-2' htmlFor="email">Email</label>
                      <Input
                        className='input-default'
                        value={filters.email}
                        onChange={(e) => setFieldFilter('email', e.target.value)}
                        type='email'
                        size="large"
                        placeholder="Email"
                      />
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={24}>
                      <Button
                        size='small'
                        className='m-2'
                        disabled={(loadingList) ? true : false}
                        loading={(loadingList) ? true : false}
                        onClick={() => handleSubmit(values)}
                        type="primary"
                      >
                        Filtrar
                      </Button>
                    </Col>
                  </Row>
                </div>
              )}
            </Formik>
          </div>
        </Modal>

        {/* Modal Actions Edit | Add */}
        <Drawer
          title={getTitle()}
          className="drawer-administrators-show"
          placement={'right'}
          closable={true}
          onClose={onCloseDrawer}
          open={openDrawer}
          key={'right'}
          closeIcon={<CloseOutlined />}
          width={drawerWidthResponsiveShow}
        >
          <>
            {
              (openTypeContentDrawer?.edit.status) &&
              <>
                <Edit dataEdit={openTypeContentDrawer?.edit?.dataEdit}></Edit>
              </>
            }

            {
              (openTypeContentDrawer?.add.status) &&
              <>
                <Add ></Add>
              </>
            }
          </>
        </Drawer>
        <FooterDefault />
      </Content>
    </>
  );
};

export default Administrators;